import session from "./session";

export default {
  fetchTickets(filters) {
    return session.get(`/tickets/`, { params: filters,  paramsSerializer: params => new URLSearchParams(params).toString() });
  },
  fetchTicketNotesByID(tID) {
    return session.get(`/tickets/${tID}/notes/`);
  },
  fetchTicketByID(tID) {
    return session.get(`/tickets/${tID}/`);
  },
  fetchTicketFilters() {
    return session.get(`/tickets/filters/`);
  },
  updateTicketData(tID,data) {
    return session.patch(`/tickets/${tID}/`,JSON.stringify(data));
  },
  addTicketNotesByID(tID,data) {
    return session.post(`/tickets/${tID}/notes/`,JSON.stringify(data));
  },
  createNewTicket(pid,data) {
    return session.post(`/products/${pid}/tickets/`,JSON.stringify(data));
  },
};
